export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_LCA_URL = process.env.REACT_APP_API_LCA_URL;

export const LOGIN_ENDPOINT = process.env.REACT_APP_LOGIN_ENDPOINT;
export const PROFILE_ENDPOINT = process.env.REACT_APP_PROFILE_ENDPOINT;
export const SECURITY_CODES_FETCH_ENDPOINT = process.env.REACT_APP_SECURITY_CODES_FETCH_ENDPOINT;
export const SEND_OTP_ENDPOINT = process.env.REACT_APP_SEND_OTP_ENDPOINT;
export const VERIFY_OTP_ENDPOINT = process.env.REACT_APP_VERIFY_OTP_ENDPOINT;
export const STUDENT_REGISTER_ENDPOINT = process.env.REACT_APP_STUDENT_REGISTER_ENDPOINT;
export const API_RESET_PASSWORD_STUDENT = process.env.REACT_APP_API_RESET_PASSWORD_STUDENT;
export const STUDENT_ACCOUNT_DELETE = process.env.REACT_APP_STUDENT_ACCOUNT_DELETE;
export const API_RESET_PASSWORD_VALIDATE_OTP_STUDENTS = process.env.REACT_APP_API_RESET_PASSWORD_VALIDATE_OTP_STUDENTS;
export const API_RESET_PASSWORD_GENERATE_OTP_STUDENTS = process.env.REACT_APP_API_RESET_PASSWORD_GENERATE_OTP_STUDENTS;
export const API_GET_DEPARTMENT = process.env.REACT_APP_API_GET_DEPARTMENT;
export const API_GET_LYNXID = process.env.REACT_APP_API_GET_LYNXID;

export const CDN_URL= process.env.REACT_APP_CDN_URL;
export const DEFAULT_PROFILE_PIC_URL = process.env.REACT_APP_DEFAULT_PROFILE_PIC_URL;
